import React from "react";
import CardLayout from "../../common/cardLayout/CardLayout";
import "./ResourcesStyles.css";
import BHIGuideline from "../../../assets/HelpfulMaterials/BHI and CoCM Guidelines.pdf"
// import BHIOverview from "../../../assets/HelpfulMaterials/BHI Provider Overview.pdf"
import liveCoaching from "../../../assets/HelpfulMaterials/Live Coaching Using Chat Features youth June 2025.pdf"
import liveCoaching_adult from "../../../assets/HelpfulMaterials/Live Coaching Using Chat Features June 2025.pdf"
// import marketing from "../../../assets/HelpfulMaterials/Marketing Rose for Success.pdf"
// import onboardingProcess from "../../../assets/HelpfulMaterials/Rose New Account Onboarding Process.pdf"
// import adultPatientPoster from "../../../assets/HelpfulMaterials/Rose Patient Poster.pdf"
// import adultPrescription from "../../../assets/HelpfulMaterials/Rose Prescription Pad.pdf"
import trifold from "../../../assets/HelpfulMaterials/Precise Digital One Pager June 2025.pdf"
import roseYouthFlyer from "../../../assets/HelpfulMaterials/Precise Digital Youth Overview Flyer.pdf"
import patientPoster from "../../../assets/HelpfulMaterials/Precise Digital Youth Patient Poster.pdf"
// import youthPrescription from "../../../assets/HelpfulMaterials/Rose Youth Prescription Pads_Final.pdf"
// import instructionManual from "../../../assets/HelpfulMaterials/Rose Instruction Manual_1.24.24.pdf"
import letter from "../../../assets/HelpfulMaterials/Precise Digital Youth Patient Letter.pdf"
import adultLetter from "../../../assets/HelpfulMaterials/Precise Digital Intro Letter to Patient Template.docx"
import adultToGuide from "../../../assets/HelpfulMaterials/Precise Digital How To Guide_July 2025 1.pdf"
import adultFlyer from "../../../assets/HelpfulMaterials/Precise Digital Overview Flyer_7.10.25.pdf"
import { disable } from "mixpanel-browser";
const MaterialPill = ({ text, link = "", disabled=false }) => {
  return (
    <div className="material-pill mb-3">
      <label>{text}</label>
      <div className="d-flex" style={{ gap: "10px" }}>
        {/* <button style={{ borderRadius: "8px" }} className="btn primary-btn">
          View
        </button> */}
        {/* <button style={{ borderRadius: "8px" }} className="btn primary-btn">
          Download
        </button> */}
        {!disabled?( <a href={link} style={{ borderRadius: "8px" }} className="btn primary-btn " target="_blank">View</a>) : (
          // <a href={link} style={{ borderRadius: "8px" }} className="btn primary-btn disabled" target="_blank">View</a>
          null
        )}
        
        <a href={link} style={{ borderRadius: "8px" }} className="btn primary-btn" target="_blank" download>Download</a>
      </div>
    </div>
  );
};

const HelpfulMaterials = () => {
  return (
    <CardLayout>
      <div className="container-fluid d-flex justify-content-start w-100 py-3">
        <h5 className="muted-text">Helpful Materials</h5>
      </div>
      <div className="container-fluid py-2">
        <strong style={{ color: "#1E293B" }}>
          {/* <label>Provider Resources</label> */}
          {process.env.REACT_APP_DASHBOARD_TYPE === "youth"? (
          <div className="container-fluid py-3 ">
            <MaterialPill text={"BHI and CoCM Guidelines"} link={BHIGuideline} />
            {/* <MaterialPill text={"BHI Provider Overview"} link={BHIOverview}/> */}
            <MaterialPill text={"Live Coaching Using Chat Features"} link={liveCoaching}/>
            {/* <MaterialPill text={"Marketing Rose for Success"} link={marketing}/> */}
            <MaterialPill text={"Precise Digital Youth Overview Flyer"} link={roseYouthFlyer}/>
            <MaterialPill text={"Precise Digital Youth Patient Poster"} link={patientPoster}/>
            {/* <MaterialPill text={"Rose Youth Prescription Pads"} link={youthPrescription}/> */}
            {/* <MaterialPill text={"Rose Instruction Manual"} link={instructionManual}/> */}
            {/* <MaterialPill text={"Precise Digital Youth Patient Overview video"} link={"https://youtu.be/6aob7XqlRaw"}/> */}
            <MaterialPill text={"Precise Digital Youth Patient Letter"} link={letter}/>
          </div>):
          (<div className="container-fluid py-3 ">
          <MaterialPill text={"BHI and CoCM Guidelines"} link={BHIGuideline} />
          <MaterialPill text={"Live Coaching Using Chat Features"} link={liveCoaching_adult}/>
          <MaterialPill text={"Precise Digital One Pager"} link={trifold}/>
          <MaterialPill text={"Precise Digital Intro Letter to Patient"} link={adultLetter} disabled={true}/>
          <MaterialPill text={"Precise Digital How To Guide"} link={adultToGuide}/>
          <MaterialPill text={"Precise Digital Patient Flyer"} link={adultFlyer}/>
          <MaterialPill text={"Precise Digital Patient Overview video"} link={"https://youtu.be/wLCqiIoLcs0"}/>
        </div>)}
        </strong>
      </div>
    </CardLayout>
  );
};

export default HelpfulMaterials;
